import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { UserIcon, KeyIcon } from 'lucide-react';

export const Route = createFileRoute('/_authenticated/settings/')({
  component: SettingsPage,
});

function SettingsPage() {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-bold">Settings</h2>
        <p className="text-gray-600 mt-2">Manage your account and API tokens</p>
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center space-x-2">
              <UserIcon className="w-5 h-5" />
              <span>Account Settings</span>
            </CardTitle>
            <CardDescription>Manage your profile and account information</CardDescription>
          </CardHeader>
          <CardContent>
            <Button onClick={() => navigate({ to: '/settings/account' })}>
              Go to Account Settings
            </Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center space-x-2">
              <KeyIcon className="w-5 h-5" />
              <span>API Tokens</span>
            </CardTitle>
            <CardDescription>Manage your personal access tokens for API and CLI access</CardDescription>
          </CardHeader>
          <CardContent>
            <Button onClick={() => navigate({ to: '/settings/api-tokens' })}>
              Go to API Tokens
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

